
























































































































































































import Vue from "vue";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { State, Action, Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import { RegistrationInfo } from "@/entities";
//import ProposalCards  from "./ProposalCards.vue";
import ProgressCircularComponent from "./../../../common/ProgressCircular/ProgressCircular.vue";
import { http } from "@/shared/https";
import Axios from "axios";
import { AppConstants as _app } from "@/shared/app.constants";

const namespace: string = "registration";

@Component({
  components: {
    ProgressCircularComponent,
  },
})
export default class RegistrationComponent extends Vue {
  @State(namespace) registration!: RegistrationInfo;
  @Action("registerApplicant", { namespace }) register: any;

  snackbar: boolean = false;
  multiLine: boolean = true;
  snackBarPosition: string = "top";
  snackBarColor: string = "red";
  snackBarBtnColor = "white";
  message: string = "";

  captchaValue: number = null;
  n1: number = Math.round(Math.random() * 10 + 1);
  n2: number = Math.round(Math.random() * 10 + 1);

  isSubmitted: boolean = false;
  progressBar: boolean = false;
  nameRules: any = [];
  emailRules: any = [];
  organizationRules: any = [];
  captchaRules: any = [];
  policyRules: any = [];
  privacyPolicy: boolean = false;
  defaultLanguage: any = [];  
  languageId: any;
  
  // Submit action
  onSubmit() {
    this.isSubmitted = true;

    // Added rules on submit action
    this.nameRules = [(v) => !!v || this.$t("Full name is required")];

    this.emailRules = [
      (v) => !!v || this.$t("E-mail is required"),
      (v) =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.registration.Email
        ) || this.$t("E-mail must be valid"),
    ];

    this.organizationRules = [
      (v) => !!v || this.$t("Organization is required"),
    ];

    this.captchaRules = [(v) => !!v || this.$t("Answer is required")];
    this.policyRules = [(v) => !!v];    

    let self = this;    
    setTimeout(function () {
      // Validate form
      if (
        (
          self.$refs.registrationForm as Vue & {
            validate: () => boolean;
          }
        ).validate()
      ) {
        self.progressBar = false;        
        let actualAnswer = self.n1 + self.n2;

        // Validate captcha
        if (actualAnswer != self.captchaValue) {
          self.message =
            self.$t("The answer you entered for the captcha was not correct") +
            ". (" +
            self.n1 +
            " + " +
            self.n2 +
            " = " +
            (self.n1 + self.n2) +
            ")";

          self.snackbar = true;
          self.snackBarColor = "red";

          self.n1 = Math.round(Math.random() * 10 + 1);
          self.n2 = Math.round(Math.random() * 10 + 1);

          self.isSubmitted = false;
        } else {
          self.progressBar = true;

          self
            .register({ registrationInfo: self.registration })
            .then((resp: any) => {
              if (resp.data.Result == "OK") {
                self.progressBar = false;
                const key: any = "registerSuccess";

                self.$router.push({
                  name: "genericNotification",
                  query: { msgId: key },
                  params: { Name: self.registration.FullName },
                });
              } else {
                self.n1 = Math.round(Math.random() * 10 + 1);
                self.n2 = Math.round(Math.random() * 10 + 1);

                self.captchaValue = null;
                self.progressBar = false;
                self.snackbar = true;
                self.snackBarColor = "red";

                // Show error from API
                let spliter = "</br>",
                  errors = "",
                  messages = resp.data.Message.split(spliter).filter((x) => x);

                for (var i = 0; i < messages.length; i++) {
                  var message = messages[i].split("@#");
                  if (message && message[1]) {
                    errors += (i + 1).toString() + ". " + message[1] + spliter;
                  } else {
                    errors += (i + 1).toString() + ". " + message[0] + spliter;
                  }
                }

                self.message = errors;
              }

              self.isSubmitted = false;
            })
            .catch((err) => {
              self.progressBar = false;
              self.snackbar = true;
              self.snackBarColor = "red";
              self.message = self.$t("Something went wrong!").toString();
              self.isSubmitted = false;
            });
        }
      } else {
        self.isSubmitted = false;
      }
    });
  }
  policyChange() {
    this.privacyPolicy == true
      ? (this.registration.PolicyAccepted = 1)
      : (this.registration.PolicyAccepted = 0);
  }

  mounted() {
    this.defaultLanguage = localStorage.getItem("language");
    this.registration.PreferredLanguageId = this.defaultLanguage == "en-US" ? _app.preferredLanguage.English : _app.preferredLanguage.French;    
  }
}
